import { encode as base64_encode } from "js-base64";

export const timeConvert = (reportDate) => {
  if (reportDate) {
    const dateTime = new Date(reportDate);
    const day = dateTime.getDate();
    const month = dateTime.toLocaleString("default", { month: "long" });
    const year = dateTime.getFullYear();
    let hours = dateTime.getHours();
    const minutes = dateTime.getMinutes();
    const period = hours >= 12 ? "PM" : "AM";
    if (hours > 12) {
      hours -= 12;
    } else if (hours === 0) {
      hours = 12;
    }
    const formattedDateTime = `${day} ${month} ${year} at ${hours}:${
      minutes < 10 ? "0" : ""
    }${minutes} ${period}`;
    return formattedDateTime;
  } else {
    return `No Date Available`;
  }
};

export const sidebarAdminTabs = [
  {
    id: 1,
    title: "Site Overview",
    img: "/icons/dashboard-icons/site_overview.svg",
    activeImg: "/icons/dashboard-active-icons/site_overview_tab.svg",
    active: "site_overview",
    children: [
      {
        id: 1,
        title: "Overview",
        img: "/icons/dashboard-icons/site_overview.svg",
        activeImg: "/icons/dashboard-active-icons/site_overview.svg",
        slug: "websiteDashboard",
      },
      {
        id: 2,
        title: "Security and Privacy",
        img: "/icons/dashboard-icons/security_privacy.svg",
        activeImg: "/icons/dashboard-active-icons/security_privacy.svg",
        slug: "security_privacy",
      },
      {
        id: 3,
        title: "Performance and Technical",
        img: "/icons/dashboard-icons/performance_technical.svg",
        activeImg: "/icons/dashboard-active-icons/performance_technical.svg",
        slug: "performance_technical",
      },
      {
        id: 4,
        title: "Integration and Services",
        img: "/icons/dashboard-icons/integration_services.svg",
        activeImg: "/icons/dashboard-active-icons/integration_services.svg",
        slug: "integration_service",
      },
      {
        id: 5,
        title: "Mobile Responsiveness",
        img: "/icons/dashboard-icons/mobile_responsive.svg",
        activeImg: "/icons/dashboard-active-icons/mobile_responsive.svg",
        slug: "mobile_responsiveness",
      },
      {
        id: 6,
        title: "Content and Information",
        img: "/icons/dashboard-icons/content_info.svg",
        activeImg: "/icons/dashboard-active-icons/content_info.svg",
        slug: "content_information",
      },
      {
        id: 7,
        title: "Interactivity and Engagement",
        img: "/icons/dashboard-icons/interactivity_engagement.svg",
        activeImg: "/icons/dashboard-active-icons/interactivity_engagement.svg",
        slug: "interactivity_engagement",
      },
      {
        id: 8,
        title: "Branding and Visual Identity",
        img: "/icons/dashboard-icons/branding_visual.svg",
        activeImg: "/icons/dashboard-active-icons/branding.svg",
        slug: "branding_visual",
      },
      {
        id: 9,
        title: "Navigation",
        img: "/icons/dashboard-icons/navigation.svg",
        activeImg: "/icons/dashboard-active-icons/navigation.svg",
        slug: "navigation",
      },

      {
        id: 10,
        title: "Accessibility",
        img: "/icons/dashboard-icons/accessibility.svg",
        activeImg: "/icons/dashboard-active-icons/accessibility.svg",
        slug: "accessibility",
      },
    ],
  },
  {
    id: 2,
    title: "DBIM Report",
    img: "/icons/dashboard-icons/survey-report.svg",
    activeImg: "/icons/dashboard-active-icons/dbim_report_tab.svg",
    active: "dbims_report_tab",
    children: [
      {
        id: 21,
        title: "DBIM Overview",
        img: "/icons/dashboard-icons/survey-report.svg",
        activeImg: "/icons/dashboard-active-icons/survey-report.svg",
        slug: "dbims_report",
      },
      {
        id: 2,
        title: "Colours",
        img: "/icons/dashboard-icons/colours.svg",
        activeImg: "/icons/dashboard-active-icons/colours.svg",
        slug: "colours",
      },
      {
        id: 3,
        title: "Iconography",
        img: "/icons/dashboard-icons/iconography.svg",
        activeImg: "/icons/dashboard-active-icons/iconography.svg",
        slug: "iconography",
      },
      {
        id: 4,
        title: "Typography",
        img: "/icons/dashboard-icons/typography.svg",
        activeImg: "/icons/dashboard-active-icons/typography.svg",
        slug: "typography",
      },
      {
        id: 5,
        title: "Logo Lockup",
        img: "/icons/dashboard-icons/logo-lockup.svg",
        activeImg: "/icons/dashboard-active-icons/logo-lockup.svg",
        slug: "logo_lockup",
      },
      {
        id: 6,
        title: "Imagery",
        img: "/icons/dashboard-icons/imagery.svg",
        activeImg: "/icons/dashboard-active-icons/imagery.svg",
        slug: "imagery",
      },
      {
        id: 7,
        title: "Content",
        img: "/icons/dashboard-icons/content.svg",
        activeImg: "/icons/dashboard-active-icons/content.svg",
        slug: "content",
      },
      {
        id: 8,
        title: "Performance Enhancement",
        img: "/icons/dashboard-icons/performance_enhancement.svg",
        activeImg: "/icons/dashboard-active-icons/performance_enhancement.svg",
        slug: "performance_enhancement",
      },
      {
        id: 9,
        title: "Header and Footer",
        img: "/icons/dashboard-icons/performance_enhancement.svg",
        activeImg: "/icons/dashboard-active-icons/performance_enhancement.svg",
        slug: "headerAndFooter",
      },
      {
        id: 10,
        title: "Search Functionality",
        img: "/icons/dashboard-icons/search_functionality.svg",
        activeImg: "/icons/dashboard-active-icons/search_functionality.svg",
        slug: "search_functionality",
      },
    ],
  },
  {
    id: 1,
    title: "Report Tab",
    img: "/icons/dashboard-icons/report.svg",
    activeImg: "/icons/dashboard-active-icons/report_tab.svg",
    active: "report_tab",
    children: [
      {
        id: 12,
        title: "Reports",
        img: "/icons/dashboard-icons/report.svg",
        activeImg: "/icons/dashboard-active-icons/reports.svg",
        slug: "reports",
      },
    ],
  },
  {
    id: 1,
    title: "Traffic",
    img: "/icons/dashboard-icons/framework.svg",
    activeImg: "/icons/dashboard-active-icons/framework_tab.svg",
    active: "traffic_tab",
    children: [
      {
        id: 14,
        title: "Traffic",
        img: "/icons/dashboard-icons/traffic.svg",
        activeImg: "/icons/dashboard-active-icons/traffic.svg",
      },
      {
        id: 15,
        title: "Traffic 2",
        img: "/icons/dashboard-icons/traffic2.svg",
        activeImg: "/icons/dashboard-active-icons/traffic2.svg",
      },
    ],
  },
  // {
  //   id: 1,
  //   title: "Framework",
  //   img: "/icons/dashboard-icons/framework.svg",
  //   activeImg: "/icons/dashboard-icons/framework.svg",
  //   active: "framework_tab",
  //   children: [
  //     {
  //       id: 13,
  //       title: "Framework",
  //       icon: "ri-pie-chart-line",
  //       img: "/icons/dashboard-icons/framework.svg",
  //       activeImg: "/icons/dashboard-active-icons/framework.svg",
  //       slug: "framework",
  //     },
  //   ],
  // },
];

export const sidebarUserTabs = [
  {
    id: 1,
    title: "Site Overview",
    img: "/icons/dashboard-icons/site_overview.svg",
    activeImg: "/icons/dashboard-active-icons/site_overview_tab.svg",
    active: "site_overview",
    children: [
      {
        id: 1,
        title: "Overview",
        img: "/icons/dashboard-icons/site_overview.svg",
        activeImg: "/icons/dashboard-active-icons/site_overview.svg",
        slug: "websiteDashboard",
      },
      {
        id: 2,
        title: "Security and Privacy",
        img: "/icons/dashboard-icons/security_privacy.svg",
        activeImg: "/icons/dashboard-active-icons/security_privacy.svg",
        slug: "security_privacy",
      },
      {
        id: 3,
        title: "Performance and Technical",
        img: "/icons/dashboard-icons/performance_technical.svg",
        activeImg: "/icons/dashboard-active-icons/performance_technical.svg",
        slug: "performance_technical",
      },
      {
        id: 4,
        title: "Integration and Services",
        img: "/icons/dashboard-icons/integration_services.svg",
        activeImg: "/icons/dashboard-active-icons/integration_services.svg",
        slug: "integration_service",
      },
      {
        id: 5,
        title: "Mobile Responsiveness",
        img: "/icons/dashboard-icons/mobile_responsive.svg",
        activeImg: "/icons/dashboard-active-icons/mobile_responsive.svg",
        slug: "mobile_responsiveness",
      },
      {
        id: 6,
        title: "Content and Information",
        img: "/icons/dashboard-icons/content_info.svg",
        activeImg: "/icons/dashboard-active-icons/content_info.svg",
        slug: "content_information",
      },
      {
        id: 7,
        title: "Interactivity and Engagement",
        img: "/icons/dashboard-icons/interactivity_engagement.svg",
        activeImg: "/icons/dashboard-active-icons/interactivity_engagement.svg",
        slug: "interactivity_engagement",
      },
      {
        id: 8,
        title: "Branding and Visual Identity",
        img: "/icons/dashboard-icons/branding_visual.svg",
        activeImg: "/icons/dashboard-active-icons/branding.svg",
        slug: "branding_visual",
      },
      {
        id: 9,
        title: "Navigation",
        img: "/icons/dashboard-icons/navigation.svg",
        activeImg: "/icons/dashboard-active-icons/navigation.svg",
        slug: "navigation",
      },

      {
        id: 10,
        title: "Accessibility",
        img: "/icons/dashboard-icons/accessibility.svg",
        activeImg: "/icons/dashboard-active-icons/accessibility.svg",
        slug: "accessibility",
      },
    ],
  },
  {
    id: 2,
    title: "DBIM Report",
    img: "/icons/dashboard-icons/survey-report.svg",
    activeImg: "/icons/dashboard-active-icons/survey-report.svg",
    active: "dbims_report_tab",
    children: [
      {
        id: 2,
        title: "Colours",
        img: "/icons/dashboard-icons/colours.svg",
        activeImg: "/icons/dashboard-active-icons/colours.svg",
        slug: "colours",
      },
      {
        id: 3,
        title: "Iconography",
        img: "/icons/dashboard-icons/iconography.svg",
        activeImg: "/icons/dashboard-active-icons/iconography.svg",
        slug: "iconography",
      },
      {
        id: 4,
        title: "Typography",
        img: "/icons/dashboard-icons/typography.svg",
        activeImg: "/icons/dashboard-active-icons/typography.svg",
        slug: "typography",
      },
      {
        id: 5,
        title: "Logo Lockup",
        img: "/icons/dashboard-icons/logo-lockup.svg",
        activeImg: "/icons/dashboard-active-icons/logo-lockup.svg",
        slug: "logo_lockup",
      },
      {
        id: 6,
        title: "Imagery",
        img: "/icons/dashboard-icons/imagery.svg",
        activeImg: "/icons/dashboard-active-icons/imagery.svg",
        slug: "imagery",
      },
      {
        id: 7,
        title: "Content",
        img: "/icons/dashboard-icons/content.svg",
        activeImg: "/icons/dashboard-active-icons/content.svg",
        slug: "content",
      },
      {
        id: 8,
        title: "Performance Enhancement",
        img: "/icons/dashboard-icons/performance_enhancement.svg",
        activeImg: "/icons/dashboard-active-icons/performance_enhancement.svg",
        slug: "performance_enhancement",
      },

      {
        id: 9,
        title: "Header and Footer",
        img: "/icons/dashboard-icons/performance_enhancement.svg",
        activeImg: "/icons/dashboard-active-icons/performance_enhancement.svg",
        slug: "headerAndFooter",
      },

      {
        id: 10,
        title: "Search Functionality",
        img: "/icons/dashboard-icons/search_functionality.svg",
        activeImg: "/icons/dashboard-active-icons/search_functionality.svg",
        slug: "search_functionality",
      },
    ],
  },
];

export const benchmarkingParameter = [
  {
    id: 1,
    icon: "https://mfscdcl.companydemo.in/images/about-img/feature/features-img-1.png",
    title: "Security and Privacy",
    description: `Evaluates the website's security measures and privacy policies to ensure the protection of user data
    and information.`,
  },
  {
    id: 2,
    icon: "https://mfscdcl.companydemo.in/images/about-img/feature/features-img-2.png",
    title: "Performance and Technical",
    description: `Assesses the technical aspects of the website, including loading speed, server uptime, and
    compatibility with different browsers and devices.`,
  },
  {
    id: 3,
    icon: "https://mfscdcl.companydemo.in/images/about-img/feature/features-img-2.png",
    title: "Integration and Services",
    description: `Examines the website's ability to integrate with other government services and provide seamless
    access to information and resources.`,
  },
  {
    id: 4,
    icon: "https://mfscdcl.companydemo.in/images/about-img/feature/features-img-3.png",
    title: "Mobile Responsiveness",
    description: `Evaluates the website's performance and user experience on mobile devices, ensuring that it is
    optimized for different screen sizes and resolutions.`,
  },
  {
    id: 5,
    icon: "https://mfscdcl.companydemo.in/images/about-img/feature/features-img-3.png",
    title: "Content and Information",
    description: `Assesses the quality, relevance, and organization of the website's content, ensuring that it meets
    the needs of users and provides accurate and up-to-date information.`,
  },
  {
    id: 6,
    icon: "https://mfscdcl.companydemo.in/images/about-img/feature/features-img-3.png",
    title: "Interactivity and Engagement",
    description: `Evaluates the website's ability to engage users through interactive features, such as online forms,
    chatbots, and social media integration.`,
  },
  {
    id: 7,
    icon: "https://mfscdcl.companydemo.in/images/about-img/feature/features-img-3.png",
    title: "Branding and Visual Identity",
    description: `Assesses the website's adherence to the government's branding guidelines and visual identity,
    ensuring consistency and professionalism across all government digital platforms.`,
  },
  {
    id: 8,
    icon: "https://mfscdcl.companydemo.in/images/about-img/feature/features-img-3.png",
    title: "Navigation",
    description: `Evaluates the website's navigation structure, ensuring that users can easily find the information
    they need and access relevant services.`,
  },
  {
    id: 9,
    icon: "https://mfscdcl.companydemo.in/images/about-img/feature/features-img-3.png",
    title: "Accessibility",
    description: `Assesses the website's compliance with accessibility standards, ensuring that it is inclusive and
    usable by people with disabilities.`,
  },
];

export const rankingToolTab = [
  {
    id: 1,
    title: "Ranking Methodology",
    description: `The ranking methodology used by this tool is based on a comprehensive scoring system that considers
  various aspects of website functionality and user experience. Websites are evaluated using a set of
  questions and sub-parameters that are derived from global best practices and industry standards. The
  scoring mechanism and weight assignments are designed to provide a fair and unbiased evaluation of
  government websites.`,
  },
  {
    id: 2,
    title: "The Tool",
    description: `The NIC Benchmarking Tool Website is a user-friendly platform that enables government entities to
  evaluate their websites and compare them with others. The tool provides a detailed report highlighting
  the strengths and weaknesses of each website, along with recommendations for improvement. By
  leveraging this tool, government agencies can optimize their online presence, enhance user experience,
  and improve their digital services.`,
  },
];

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// result_date result date ["result","date"]
export const upperCaseLetter = (text) => {
  if (!text) return "";
  const textArr = text.replace(/_/g, " ").split(" ");
  for (let i = 0; i < textArr.length; i++) {
    textArr[i] = textArr[i].charAt(0).toUpperCase() + textArr[i].slice(1);
  }
  return textArr.join(" ");
};

export const enhancePerformance = () => {
  console.log = function () {};
  console.warn = function () {};
  console.error = function () {};
};

export const dashMenu = [
  {
    id: 1,
    title: "My Profile",
    icon: "ri-file-user-line",
    description: "View personal profile details.",
  },
  {
    id: 2,
    title: "Edit Profile",
    icon: "ri-profile-line",
    description: "Modify your personal details.",
  },
];

export const sliderData = [
  {
    imgSrc: "images/benefits-icons/web-speed.png",
    title: "Enhanced Website Speed <br /> and Performance",
    description:
      "Websites that load swiftly and seamlessly offer an improved user experience, potentially resulting in heightened engagement, conversions, and revenue.",
  },
  {
    imgSrc: "images/benefits-icons/ui-ux.png",
    title: "Improved User Interaction <br /> and Satisfaction",
    description:
      "A positive user experience facilitates visitors in locating desired information, accomplishing tasks, and enjoying their visit on your site. This often results in heightened engagement, allegiance, and support.",
  },
  {
    imgSrc: "images/benefits-icons/website-traffic.png",
    title: "Enhanced Website Visibility <br /> and Traffic",
    description:
      "Websites ranking well on search engine results pages (SERPs) tend to attract more potential visitors, potentially resulting in a rise in traffic, leads, and sales.",
  },
  {
    imgSrc: "images/benefits-icons/Vulnerabilities.png",
    title: "Mitigated Security <br /> Risks",
    description:
      "Websites regularly updated with security patches and fortified with robust security measures reduce the likelihood of unauthorized access or compromises. This ensures safeguarding your data and upholding your reputation.",
  },
  {
    imgSrc: "images/benefits-icons/data-driven.png",
    title: "Informed Decision-Making <br /> Through Data",
    description:
      "Websites equipped to gather and analyze data are better equipped to enhance their design, content, and marketing strategies. This approach can result in improved efficiency, effectiveness, and potential gains.",
  },
];

export const dashboard_footerData = [
  { id: 1, title: "Terms and Conditions", route: "/terms_condition" },
  { id: 2, title: "Feedback", route: "/feedback" },
];

export const footerData = [
  { id: 1, title: "About", route: "/about" },
  { id: 2, title: "Terms and Conditions", route: "/terms_condition" },
  // { id: 3, title: "Contact us", route: "/contact_us" },
  // { id: 4, title: "Feedback", route: "/feedback" },
  { id: 5, title: "FAQ", route: "/faq" },
];

export const fontSizeTab = [
  {
    id: 1,
    className: "increaseFont",
    tooltip_title: "Increase font size",
    title: "A",
    super: "+",
  },
  {
    id: 1,
    className: "resetFont",
    tooltip_title: "Reset font size",
    title: "A",
  },
  {
    id: 1,
    className: "decreaseFont",
    tooltip_title: "Decrease font size",
    title: "A",
    super: "-",
  },
];

export const tabColor = [
  {
    id: 1,
    className: "colorBox dark-contrast",
    tooltip_title: "High contrast dark",
    title: "A",
    id: "blackBtn",
  },
  {
    id: 1,
    className: "colorBox light-contrast",
    tooltip_title: "",
    title: "A",
    id: "whiteBtn",
  },
];

export const scripts = [
  "js/jquery.min.js",
  "js/font.js",
  "vendor/owl.carousel.js",
  "js/dz.carousel.js",
];

// Load a single script
export const loadScript = (src) => {
  return new Promise((resolve, reject) => {
    const existingScript = document.querySelector(`script[src="${src}"]`);
    if (existingScript) {
      // Skip loading if already present
      console.log(`Script already loaded: ${src}`);
      resolve();
      return;
    }
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.defer = true;
    script.onload = resolve;
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.body.appendChild(script);
  });
};

// Remove all loaded scripts
export const removeScripts = () => {
  scripts.forEach((src) => {
    const existingScript = document.querySelector(`script[src="${src}"]`);
    if (existingScript) {
      existingScript.remove();
    }
  });
  console.log("Old scripts removed");
};

export const checkSurveyFilled = (apiData, payloadData) => {
  const filteredData = {};
  Object.keys(apiData)?.filter((key) => {
    if (Array.isArray(apiData[key])) {
      filteredData[key] = apiData[key];
    }
  });
  const check = Object.keys(filteredData)
    ?.map((item) => filteredData[item]?.length === payloadData[item]?.length)
    .every((result) => result);
  return check;
};

export const sortedQuestions = (arr = []) => {
  const arrCopy = [...arr];
  return arrCopy.sort((a, b) => {
    if (a.description && !b.description) {
      return -1;
    } else if (!a.description && b.description) {
      return 1;
    } else {
      return 0;
    }
  });
};

export const getRandom8Digits = () => {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < 8; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

export const splitStringWithRandomDigits = (str) => {
  let parts = splitStringIntoThreeParts(str); // Split the string into three parts

  return `${getRandom8Digits()}$${base64_encode(
    base64_encode(parts[0])
  )}$${getRandom8Digits()}$${base64_encode(
    base64_encode(parts[1])
  )}$${getRandom8Digits()}$${base64_encode(base64_encode(parts[2]))}`;
};

export const splitStringIntoThreeParts = (str) => {
  if (str.length <= 2) {
    return [str, "", ""];
  } else if (str.length <= 4) {
    return [str.slice(0, 2), str.slice(2), ""];
  } else {
    return [str.slice(0, 2), str.slice(2, 4), str.slice(4)];
  }
};
